// @flow
import React from 'react';

import { I18n } from '@lingui/react';
import Input, { type Props as InputProps } from '../Input';

const handleChange = (value, onChange, postalRegExp) => {
  if (!onChange) return;

  const cleanedValue = value.toUpperCase();

  if (postalRegExp) {
    if (postalRegExp.test(cleanedValue)) {
      onChange(cleanedValue);
    }
  } else {
    onChange(cleanedValue);
  }
};

export type Props = InputProps & {
  postalRegExp?: ?RegExp,
};

const ZipcodeInput = ({ onChange, postalRegExp, ...other }: Props) => (
  <I18n>
    {({ i18n }) => (
      <Input
        name="zipcode"
        type="text"
        placeholder={i18n._('Postal Code')}
        autoComplete="postal-code"
        onChange={value => handleChange(value, onChange, postalRegExp)}
        {...other}
      />
    )}
  </I18n>
);

export default ZipcodeInput;



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/ZipcodeInput/ZipcodeInput.jsx